import React from 'react';
import * as FaIcons from 'react-icons/fa';

import * as RiIcons from 'react-icons/ri';
import * as MdIcons from 'react-icons/md';


export const DataMenuBackoffice = [
  {
      title: 'Backoffice',
      path: 'backofice',
      icon: <MdIcons.MdAdminPanelSettings />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
  
      subNav: [
  
        {
          title: 'Registrar Empresa',
          path: 'backofice/agregarempresa',
          icon: <FaIcons.FaDeezer />
        },
        {
          title: 'Estado Tenant',
          path: 'backofice/estado-tenant',
          icon: <FaIcons.FaServer />
        },
        {
          title: 'Contratos de Mantencion',
          path: 'backofice/contrato-mantencion',
          icon: <FaIcons.FaFileContract />
        },   
        {
          title: "Usuarios de la Plataforma",
          path: "backofice/usuarios",
          icon: <FaIcons.FaUsers />
        }
      ]
    }
];